import React from 'react';
import ReactDOM from 'react-dom';
import App from './modules/app/App';
import reportWebVitals from './monitoring/reportWebVitals';

import './css/index.css';
import 'semantic-ui-less/semantic.less'

import './i11n/i18n';

import Amplify from 'aws-amplify';
import awsExports from './aws-exports';

Amplify.configure(awsExports);

// window.LOG_LEVEL = 'DEBUG';

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
